<template>
  <main>
    <div class="container-fluid pt-3">

      <div class="card shadow-lg ">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col my-auto">
              <div class="h-100">
                <h5 class="mb-1">{{id}}</h5>
                <p class="mb-0 font-weight-bold text-sm">{{CheckAuth(auth)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12  mb-4">
          <div class="card">
            <div class="card-body">
              <p class="text-uppercase text-sm">관리자정보</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">아이디</label>
                  <input class="form-control" type="text" v-model="id" readonly />
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">코인정보</p>
              <div class="row">
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label">지갑주소</label>
                  <input class="form-control" type="text" v-model="address" readonly />
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">TRON 보유개수</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="tron_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="GetAdminDetail()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">USDT 보유개수</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="usdt_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="GetAdminDetail()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">MCS 보유개수</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="mcs_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="GetAdminDetail">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-xl-6 mt-2">
                  <button type="button" class="btn btn-primary" @click="ResetPassword()" >비밀번호 초기화</button>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="modal" tabindex="-1" id="wallet_add">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">코인 추가</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">접속자 보유개수</label>
            <input type="text" class="form-control" v-model="t_balance" readonly/>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">지갑주소</label>
            <input type="text" class="form-control" v-model="address" readonly/>
            <label for="example-text-input" class="form-control-label">추가할 개수</label>
            <input type="text" class="form-control" v-model="add_balance"/>
            <label for="example-text-input" class="form-control-label">메모</label>
            <input type="text" class="form-control" v-model="add_memo"/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="WalletAdd()">추가</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" id="wallet_sub">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">코인 차감</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">지갑 보유개수</label>
            <input type="text" class="form-control" v-model="balance" readonly/>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">차감할 개수</label>
            <input type="text" class="form-control" v-model="sub_balance"/>
            <label for="example-text-input" class="form-control-label">메모</label>
            <input type="text" class="form-control" v-model="sub_memo"/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="WalletSub()">회수</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
const exactMath = require('exact-math');
import { mapMutations } from "vuex";
const CryptoJS = require("crypto-js");

export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      no :this.$route.params.no,
      id : '',
      auth : '',
      address : '',
      tron_balance : '',
      usdt_balance : '',
      mcs_balance : '',
      site : '',
      site_address : '',
      t_balance : '',
      add_balance : '',
      add_memo : '',
      sub_balance : '',
      sub_memo : '',
      AddModal :'',
      SubModal : '',
      mobile :this.$store.state.mobile,
      show_mobile :this.$store.state.show_mobile,
    };
  },
  components: {  },

  mounted() {
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    this.$store.state.isAbsolute = false;
    this.GetAdminDetail();
    // this.AddModal = new Modal(document.getElementById('wallet_add'));
    // this.SubModal = new Modal(document.getElementById('wallet_sub'));
    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      }
    }
  },
  methods:{
    ...mapMutations(["navbarMinimize"]),
    CheckAuth(auth){
      if(auth =='SA'){
        return "사이트 관리자"
      }else if(auth =='A'){
        return "관리자"
      }
    },
    ResetPassword(){
      const code= this.no;
      const body = {code};
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
      this.axios.post('/admin/admin/ResetPassword', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("비밀번호를 초기화했습니다. 초기화 비밀번호는 고객 이메일로 전송하였습니다.").then(
                ()=>{
                  this.$router.go()
                }
              )
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },

    GetAdminDetail(){
      const code= this.no;
      const body = {code};

			const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
      this.axios.post('/admin/admin/detail', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)

              const info = body.info;
              const wallet = body.wallet;
              this.id = info.email;
              this.auth = info.auth;
              this.address = wallet.address;
              this.tron_balance = wallet.balance;
              this.usdt_balance = body.usdt_balance;
              this.mcs_balance = body.mcs_balance;
            }else if(res.data.code=='500'){
              this.$alert.alert("잘못된경로입니다.").then(()=>{
                this.$router.go(-1);
              })
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    GetTokenBalance(){
      this.axios.post('/admin/common/token/balance', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.t_balance = res.data.balance;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    OkClick(){
      this.$refs.AddWalletBtn.$el.click();
    },
    WalletAdd(){
      const t_balance = this.t_balance;
      const balance = this.add_balance;
      if(balance ==0 ||balance ==''){
        this.$alert.alert("추가할 코인 개수를 확인해주세요.").then(
          ()=>{
             this.AddModal.show();
          }
        )
        return false;
      }

      const c_balance = exactMath.sub(t_balance,balance);

      if(c_balance < 0 ){
        this.$alert.alert("보유하신 코인을 확인해주세요.").then(
          ()=>{
             this.AddModal.show();
          }
        )
        return false;
      }

      const uid = this.no;
      const memo = this.add_memo;


      this.axios.post('/admin/admin/token/add', {uid,balance,memo}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("처리 완료하였습니다.").then(
                ()=>{
                  this.$router.go();
                }
              )
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    WalletSub(){
      const t_balance = this.balance;
      const balance = this.sub_balance;
      if(balance ==0 ||balance ==''){
        this.$alert.alert("회수할 코인 개수를 확인해주세요.").then(
          ()=>{
             this.SubModal.show();
          }
        )
        return false;
      }

      const c_balance = exactMath.sub(t_balance,balance);

      if(c_balance < 0 ){
        this.$alert.alert("보유하신 코인을 확인해주세요.").then(
          ()=>{
             this.SubModal.show();
          }
        )
        return false;
      }

      const uid = this.no;
      const memo = this.sub_memo;


      this.axios.post('/admin/admin/token/sub', {uid,balance,memo}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("처리 완료하였습니다.").then(
                ()=>{
                  this.$router.go();
                }
              )
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    }
  }
};
</script>
